import React from 'react';

interface PromptConfirmationModalProps {
  isVisible: boolean;
  selectedPrompt: {
    prompt: string;
    wordCount: string;
    type: string;
  } | null;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
}

const PromptConfirmationModal: React.FC<PromptConfirmationModalProps> = ({
  isVisible,
  selectedPrompt,
  onConfirm,
  onCancel,
  title = "Confirm Prompt Selection"
}) => {
  if (!isVisible || !selectedPrompt) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">{title}</h3>
        <div className="mb-4">
          <div className="mb-2">
            <span className="font-medium text-gray-900 dark:text-gray-100">Word Count: </span>
            <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200 rounded-full text-xs">
              {selectedPrompt.wordCount} words
            </span>
          </div>
          <div>
            <span className="font-medium text-gray-900 dark:text-gray-100">Prompt: </span>
            <p className="mt-1 text-gray-700 dark:text-gray-300">{selectedPrompt.prompt}</p>
          </div>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 dark:bg-blue-700 text-white rounded hover:bg-blue-700 dark:hover:bg-blue-600"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptConfirmationModal;
